// extracted by mini-css-extract-plugin
export default {"wrapper":"personal-account_wrapper__nlf0z","container":"personal-account_container__JnfHn"};